// src/business-types/saloon/modules/home/hooks/useOrderFlow.ts
import { StylingStaff, SelectProduct } from "../types/salon.types";

export const useOrderFlow = (
  selectedStaff: StylingStaff | null,
  resetPaymentState: () => void,
  clearOrder: () => void,
  // Add new parameters for resetting UI state
  resetStaffSelection?: () => void,
  resetCategorySelection?: () => void,
  resetActiveTab?: () => void
) => {
  const resetOrderFlow = () => {
    clearOrder();
    // resetPaymentState();
    // resetStaffSelection?.();
    resetCategorySelection?.();
    resetActiveTab?.();
    // window.location.reload();
  };

  const validateOrder = (products: SelectProduct[]) => {
    if (products.length === 0) {
      return false;
    }
    return true;
  };

  return { resetOrderFlow, validateOrder };
};
